export var getIsRequiredError = function getIsRequiredError(_ref) {
  var getIsEmpty = _ref.getIsEmpty,
      isRequired = _ref.isRequired;

  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      value = _ref2.value;

  return isRequired && getIsEmpty(value);
};